import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'moment/locale/pt-br';
import 'react-circular-progressbar/dist/styles.css';

import { sendCreateProfile } from '../../services/vendors/mixpanel';
import { AppCuesIdentify } from '../../services/vendors/appcues';
import { Text } from '../../styles/common';
import { branco } from '../../styles/colors';
import { ButtonPrimary } from './styles';
import { ContentPage } from '../_layouts/styles/common';
import { Col, Row } from '../../styles/grid';

import { massMessage } from '../../routes/routeMap';
import history from '../../services/history';
import px2vw from '../../utils/responsiveness/px2vw';

import {
  getOrdersRequest,
  getOrdersClearSuccess,
} from '../../store/modules/orders/actions';

import {
  getOrdersMetricsRequest,
  getGameficationRequest,
} from '../../store/modules/dashboardMetrics/actions';

import Gamefication from './Gamification';
import Reports from './Reports';
import TermsAndPoliciesModal from '../../components/TermsAndPoliciesModal';

export default function Dashboard() {
  const hasFreeTrialValid = useSelector(
    (state) => state.user.hasFreeTrialValid
  );
  const st = useSelector(
    (state) => state
  );
  const userData = useSelector((state) => state.user);
  const user = useSelector((state) => state.user.user);
  const advPlan = user.advertiserInfo.advertiserSubscription;
  const getOrdersSuccess = useSelector(
    (state) => state.orders.getOrdersSuccess
  );
  const dispatch = useDispatch();
  // Initialize Appcues
  useEffect(() => {
    AppCuesIdentify(userData);
  }, [window.Appcues]);

  useEffect(() => {
    dispatch(getOrdersMetricsRequest(true));
    dispatch(getGameficationRequest());

    //Mixpanel Event
    sendCreateProfile({
      id: user.advertiserInfo.id,
      email: user.email,
      name: user.advertiserInfo.name,
      created_at: user.created_at,
      city: user.address[0].city,
      state: user.address[0].state,
      advertiserCategory: user.advertiserInfo.advertiserCategory.name,
      advertiserPlan: advPlan[advPlan.length - 1].subscription.name,
      advertiserPlanAmount: advPlan[advPlan.length - 1].subscription.amount,
      hasFreeTrialValid: hasFreeTrialValid,
    });
  }, []);

  useEffect(() => {
    if (getOrdersSuccess) {
      dispatch(getOrdersClearSuccess());
    }
  }, [getOrdersSuccess, dispatch]);

  return (
    <>
      <ContentPage>
        <Row spaceBetween width="100%" height="auto">
          <Gamefication />
        </Row>
        <Col
          justifyStart
          pad={px2vw(21)}
          margtop={px2vw(20)}
          borderRadius={px2vw(10)}
          background="linear-gradient(172.89deg, rgb(212 44 44) -11.6%)"
          height={px2vw(150)}
          width="100%"
          relative
        >
          <img src={require('../../assets/images/dashboard_icon/alert.png')} style={{position: 'absolute', right: px2vw(10), bottom: px2vw(10), height: px2vw(120)}} />
          <Col margbottom={px2vw(5)} height="auto" justifyStart>
            <Text size={px2vw(22)} margbottom={px2vw(10)} color={branco} bold>
              🚨 Atenção: A Kuppi encerrará suas atividades em 31/07/2025!
            </Text>
          </Col>

          <Col relative height="auto" width="80%" justifyStart>
            <Text size={px2vw(15)} regular margbottom={px2vw(4)} color={branco}>
              Estamos migrando nossos serviços para a{' '}
              <strong style={{ margin: `0 ${px2vw(5)}` }}>
                Yooga
              </strong>
              . Garanta sua continuidade sem interrupções!
            </Text>
            <Text size={px2vw(15)} regular color={branco}>
              Fale agora com nosso atendimento para entender o processo de<br />migração e garantir suas operações.
            </Text>

            <ButtonPrimary
              color="red"
              bgColor="white"
              width={px2vw(220)}
              size={px2vw(14)}
              height={px2vw(38)}
              onClick={() => {
                window.open('https://wa.me/5521977099367?text=Ol%C3%A1%2C%20gostaria%20de%20entender%20sobre%20a%20descontinuidade%20da%20Kuppi%20e%20migra%C3%A7%C3%A3o%20para%20Yooga');
              }}
              style={{
                position: 'absolute',
                right: 0,
                top: '75%',
                transform: 'translateY(-50%)',
                fontWeight: 700,
                letterSpacing: '2%',
                borderRadius: px2vw(8)
              }}
            >
              💬 Falar com o atendimento
            </ButtonPrimary>
          </Col>
        </Col>
        <Reports />
      </ContentPage>
      {/* Show terms and policies modal even the onboarding is done */}
      {!user.advertiserInfo.is_terms_accepted && (
        <TermsAndPoliciesModal
          isVisible={!user.advertiserInfo.is_terms_accepted}
        />
      )}
    </>
  );
}
